import api from "../../../services/api";
import type { PeriodType } from "../hooks/useAccountingWholesale";


export const getWholesaleAccountingOverview = async (periodType: PeriodType) => {
  const response = await api.get(`/api/wholesale/accounting/revenue_overview`, {
    params: { period_type: periodType },
  });
  return response.data.accounting_dashboard;
};
